// extracted by mini-css-extract-plugin
export default {"select":"LanguageSelector_select_KmQor"};